import { render, staticRenderFns } from "./SentDialogDelete.vue?vue&type=template&id=7f12821e&scoped=true&"
import script from "./SentDialogDelete.vue?vue&type=script&lang=js&"
export * from "./SentDialogDelete.vue?vue&type=script&lang=js&"
import style0 from "./SentDialogDelete.vue?vue&type=style&index=0&id=7f12821e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12821e",
  null
  
)

export default component.exports